/**
 * @generated SignedSource<<d707aa17b494a61e6140373c85995436>>
 * @relayHash 36f88eb712e05dc13247c4718f3f0f84
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 250992659148c230d6416e91f183dbc32b134c76c1d124feac820730a1601e65

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { FieldsPageViewQuery } from './FieldsPageViewQuery.graphql';

const node: PreloadableConcreteRequest<FieldsPageViewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "250992659148c230d6416e91f183dbc32b134c76c1d124feac820730a1601e65",
    "metadata": {},
    "name": "FieldsPageViewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
